// extracted by mini-css-extract-plugin
module.exports = {"main":"PublicationDateFilterShortcut_main__oJ4ny","dropdown":"PublicationDateFilterShortcut_dropdown__jMS_l"};